import { render, staticRenderFns } from "./GliEditorButton.vue?vue&type=template&id=450a6aec&"
import script from "./GliEditorButton.vue?vue&type=script&lang=js&"
export * from "./GliEditorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports